<!-- Need to determine if the page is on a Mobile screen or not. There are various changes for Mobile, Logged In and Logged Out user -->
<template>
  <div v-if="!isMobile" class="blog-section">
    <div class="blog-section__container">
      <a data-lion-refer class="blog-section__card" href="">
        <img :src="liquid.content_1.image.src" :alt="liquid.content_1.image.alt" />
        <div class="blog-section__title h6">
          <span class="blog-section__title-label">{{ liquid.content_1.title }}</span>
          <span class="button__icon blog-section__title-icon"><svg class="icon icon__arrow icon__arrow--right" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H3.46154C2.65435 13 2 12.5523 2 12C2 11.4477 2.65435 11 3.46154 11L20 11Z"></path><path d="M13.2942 6.11527C12.9052 5.72567 12.9054 5.09457 13.2947 4.70527C13.6842 4.31576 14.3158 4.31576 14.7053 4.70527L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L14.7053 19.2947C14.3158 19.6842 13.6842 19.6842 13.2947 19.2947C12.9054 18.9054 12.9052 18.2743 13.2942 17.8847L19.17 12L13.2942 6.11527Z"></path></svg></span>
        </div>
        <p class="blog-section__description body-1"
        v-html="$cleanRTE(liquid.content_1.subtitle)" />
      </a>
      <a class="blog-section__card" href="#start-earning">
        <img :src="liquid.content_2.image.src" :alt="liquid.content_2.image.alt" />
        <div class="blog-section__title h6">
          <span class="blog-section__title-label">{{ liquid.content_2.title }}</span>
          <span class="button__icon blog-section__title-icon"><svg class="icon icon__arrow icon__arrow--right" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H3.46154C2.65435 13 2 12.5523 2 12C2 11.4477 2.65435 11 3.46154 11L20 11Z"></path><path d="M13.2942 6.11527C12.9052 5.72567 12.9054 5.09457 13.2947 4.70527C13.6842 4.31576 14.3158 4.31576 14.7053 4.70527L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L14.7053 19.2947C14.3158 19.6842 13.6842 19.6842 13.2947 19.2947C12.9054 18.9054 12.9052 18.2743 13.2942 17.8847L19.17 12L13.2942 6.11527Z"></path></svg></span>
        </div>
        <p class="blog-section__description body-1"
        v-html="$cleanRTE(liquid.content_2.subtitle)" />
      </a>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import HighlighterTitle from '~global/highlighter-title/highlighter-title'
import Btn from '~global/btn/btn'

export default {
  name: 'LoyaltyLion',
  components: {
    HighlighterTitle,
    Btn
  },

  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: () => ({
        content_1: {
          title: '',
          subtitle: '',
          image: {},
        },
        content_2: {
          title: '',
          subtitle: '',
          image: {},
        },
      }),
    }
  },

  data() {
    return {
      tierName: '',
      customerPoints: loyaltylion.customer?.pointsTotal || 0,
      isPinterestCompleted: false,
      isTiktokCompleted: false,
      birthdayText: 'Celebrate',
      claimedRewards: [],
    }
  },

  computed: {

    /**
     * Map Vuex state.
    */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

  },

  mounted() {

    this.setComponentState({ handle: 'loyalty-lion-blog', state: 'active' })

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const navElement = document.getElementById("shopify-section-site-header");
          const navbarHeight = navElement.getBoundingClientRect().height;
          const offset = targetElement.getBoundingClientRect().top - navbarHeight;

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          window.scrollTo({
            top: offset + scrollTop,
            behavior: 'smooth'
          });
        }
      });
    });

  },

  methods: {

    /**
     * Map Vuex actions.
    */
    ...mapActions({
      setComponentState: 'components/setState',
    }),

  },
}
</script>

<style lang="scss">
@import './loyalty-lion-blog';
</style>
